import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3f757860/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import items from '../../../data/components/dropdown.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Default`}</h2>
    <ComponentDemo scope={{
      items
    }} knobs={{
      Dropdown: ['light', 'disabled']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/dropdown--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-dropdown--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdropdown--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=dropdown'
    }} mdxType="ComponentDemo">{`
<Dropdown
  ariaLabel="Dropdown"
  id="carbon-dropdown-example"
  items={items}
  label="Dropdown menu options"
  titleText="This is a dropdown title."
/>
`}</ComponentDemo>
    <h2>{`ComboBox`}</h2>
    <ComponentDemo scope={{
      items
    }} knobs={{
      ComboBox: ['light', 'disabled']
    }} links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/combobox--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-combobox--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvcombobox--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=combo-box'
    }} mdxType="ComponentDemo">{`
<ComboBox
  ariaLabel="ComboBox"
  id="carbon-combobox-example"
  items={items}
  label="ComboBox menu options"
  titleText="This is a dropdown title."
/>
`}</ComponentDemo>
    <h2>{`MultiSelect`}</h2>
    <ComponentDemo scope={{
      items
    }} knobs={{
      MultiSelect: ['light', 'disabled']
    }} links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/multiselect--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-combobox--multi-select',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvmultiselect--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=multi-select'
    }} mdxType="ComponentDemo">{`
<MultiSelect
  ariaLabel="MultiSelect"
  id="carbon-multiselect-example"
  items={items}
  label="MultiSelect menu options"
  titleText="This is a dropdown title."
/>
`}</ComponentDemo>
    <h2>{`Filterable MultiSelect`}</h2>
    <ComponentDemo scope={{
      items
    }} knobs={{
      MultiSelect: ['light', 'disabled']
    }} links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/multiselect--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-combobox--multi-select',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvmultiselect--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=multi-select'
    }} mdxType="ComponentDemo">{`
<MultiSelect.Filterable
  ariaLabel="Filterable MultiSelect"
  id="carbon--filterable-multiselect-example"
  items={items}
  label="Filterable MultiSelect options"
  titleText="This is a MultiSelect title."
/>
`}</ComponentDemo>
    <h2>{`Sample data`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const items = [
  {
    id: 'option-1',
    text: 'Option 1',
  },
  {
    id: 'option-2',
    text: 'Option 2',
  },
  {
    id: 'option-3',
    text: 'Option 3',
  },
  {
    id: 'option-4',
    text: 'Option 4',
  },
];
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      